import { Box, CheckboxGroup, Image } from "components/ui";
import React from "react";

interface PageImageProps {
	imageUrl: string;
}

export const PageImage = ({ imageUrl, ...props }: PageImageProps) => {
	let defaultImage = "https://via.assets.so/img.jpg?w=500&h=140&tc=gray&bg=white&t=Upload Image";
	return (
		<Box
			minHeight={370}
			flex={1}
			style={{
				position: "relative",
				overflow: "hidden",
				borderRadius: 12,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Image
				source={imageUrl ? imageUrl : defaultImage}
				style={{
					width: "100%",
					height: "100%",
					resizeMode: "contain",
				}}
			/>
		</Box>
	);
};
